import { useEffect, useState } from "react";
import { session } from "./api";

/** Current session ({ access, refresh, user }) for "parent" or "alumni"; re-renders on login/logout. */
export default function useSession(role) {
  const [value, setValue] = useState(() => session.get(role));
  useEffect(() => {
    const update = () => setValue(session.get(role));
    const unsubscribe = session.subscribe((changed) => changed === role && update());
    window.addEventListener("storage", update);
    return () => {
      unsubscribe();
      window.removeEventListener("storage", update);
    };
  }, [role]);
  return value;
}
